import { all } from "redux-saga/effects";
import auth from "../saga/authSaga";
import examPanelSaga from "../saga/examPortalSaga";

export default function* rootSaga() {
  yield all([auth(), examPanelSaga()]);
}
